import { useNavigate } from 'react-router-dom';

export default function RefCTA() {
  const navigate = useNavigate();

  return (
    <section className="py-24 bg-zinc-950 border-t border-zinc-800/60">
      <div className="max-w-3xl mx-auto px-6 text-center">
        <div className="inline-flex items-center gap-2 bg-orange-500/10 border border-orange-500/20 rounded-full px-4 py-1.5 mb-6">
          <i className="ri-rocket-2-fill text-orange-400 text-sm" />
          <span className="text-orange-300 text-sm font-semibold">Chcete byť ďalší?</span>
        </div>
        <h2 className="text-4xl md:text-5xl font-black text-white mb-5 leading-tight">
          Váš projekt môže byť <br />
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-orange-400 to-amber-400">
            ďalší na tejto stránke
          </span>
        </h2>
        <p className="text-zinc-400 text-lg mb-10 max-w-xl mx-auto">
          Konzultácia je zadarmo. Pozrieme sa na váš web, e-shop alebo nápad
          a poviete nám, kde chcete byť o 6 mesiacov.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <button
            onClick={() => { navigate('/'); setTimeout(() => { const el = document.querySelector('#kontakt'); if (el) el.scrollIntoView({ behavior: 'smooth' }); }, 300); }}
            className="bg-orange-500 hover:bg-orange-400 text-white font-bold px-8 py-4 rounded-xl transition-all duration-200 whitespace-nowrap cursor-pointer text-sm"
          >
            Konzultácia zadarmo
          </button>
          <button
            onClick={() => navigate('/o-nas')}
            className="bg-zinc-800 hover:bg-zinc-700 border border-zinc-700/60 text-white font-semibold px-8 py-4 rounded-xl transition-all duration-200 whitespace-nowrap cursor-pointer text-sm"
          >
            Zistiť viac o nás
          </button>
        </div>

        {/* Trust indicators */}
        <div className="flex flex-wrap items-center justify-center gap-6 mt-10">
          {[
            { icon: 'ri-time-line', text: 'Odpoveď do 24h' },
            { icon: 'ri-shield-check-line', text: 'Bez záväzkov' },
            { icon: 'ri-map-pin-line', text: '100% SK tím' },
          ].map((item) => (
            <div key={item.text} className="flex items-center gap-2">
              <i className={`${item.icon} text-orange-400 text-base`} />
              <span className="text-zinc-400 text-sm">{item.text}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
